<template>
  <div>
    <el-dialog
      :visible.sync="isDialogVisible"
      @close="closeDialog"
      width="518px"
    >
      <div class="title">
        <img
          src="../../assets/img/home/litilelogo.png"
          alt="SVG Image"
          class="hand"
        />
        <div class="title-text">
          <span v-if="isRegister">用户注册</span> <span v-else>用户登录</span>
        </div>
      </div>
      <el-form
        :model="form"
        ref="formRef"
        :rules="rules"
        label-width="120px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item
          v-if="isRegister"
          style="margin-left: -100px;"
          label=""
          prop="type"
        >
          <el-radio-group
            v-model="form.type"
            size="small"
            style="margin-bottom: 20px;"
          >
            <el-radio :label="0" class="circle-radio">个人用户</el-radio>
            <el-radio :label="1" class="circle-radio">企业用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="isRegister" label="选择省市" prop="deptId">
          <template #label>
            <img
              src="@/assets/img/dizhi.png"
              alt="手机号图标"
              style="
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />
            <span style="vertical-align: middle; color: #333; font-size: 16px;"
              >选择省市</span
            >
          </template>
          <el-select
            v-model="form.deptId"
            class="neddselect"
            placeholder="请选择省市"
          >
            <el-option
              v-for="province in provinces"
              :key="province.value"
              :label="province.label"
              :value="province.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isRegister" label="选择行业" prop="selectedTrade">
          <template #label>
            <img
              src="@/assets/img/hangye.png"
              alt="手机号图标"
              style="
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />
            <span style="vertical-align: middle; color: #333; font-size: 16px;"
              >选择行业</span
            >
          </template>
          <!-- <el-select v-model="form.industry" placeholder="选择行业">
            <el-option
              v-for="industry in industryes"
              :key="industry.value"
              :label="industry.label"
              :value="industry.value"
            >
            </el-option>
          </el-select> -->
          <el-cascader
            v-model="form.selectedTrade"
            :options="cascaderData"
            :show-all-levels="false"
            class="neddselect"
            :props="{
              label: 'tradeName',
              value: 'tradeName',
              children: 'children',
            }"
            placeholder="请选择行业"
            @change="handleCascaderChange"
          ></el-cascader>
        </el-form-item>

        <el-form-item v-if="showQRCode == false" label="手机号" prop="username">
          <template #label>
            <img
              src="@/assets/img/wode.png"
              alt="手机号图标"
              style="
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />
            <span style="vertical-align: middle; color: #333; font-size: 16px;"
              >手机号</span
            >
          </template>
          <el-input
            class="neddselect"
            v-model="form.username"
            @input="validatePhoneNumber"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="showQRCode == false"
          label="密码"
          prop="password"
          style="margin-bottom: 40px;"
        >
          <template #label>
            <img
              src="@/assets/img/mima.png"
              alt="手机号图标"
              style="
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />
            <span style="vertical-align: middle; color: #333; font-size: 16px;"
              >密码</span
            >
          </template>
          <el-input
            v-model="form.password"
            :type="confirmPasswordType"
            class="neddselect"
            placeholder="请输入密码"
          >
            <template #suffix>
              <i
                :class="[
                  'el-icon-view',
                  {
                    'el-icon-view-active': confirmPasswordType === 'text',
                  },
                ]"
                @click="toggleConfirmPasswordView"
              ></i> </template
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="code"  label="密码"      v-if="showQRCode == false">
          <template #label>
            <img
              src="@/assets/img/codes.png"
              alt="手机号图标"
              style="
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />
            <span style="vertical-align: left;color: #333; font-size: 16px;">验证码</span>
          </template>
        <el-input
          v-model="form.code"
        
          auto-complete="off"
          placeholder="请输入验证码"
          style="width: 65%"
         
        >
          <template #prefix><svg-icon icon-class="validCode" class="el-input__icon input-icon" /></template>
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item> -->
        <!-- <el-form-item v-if="isRegister" label="验证码" prop="verificationCode">
          <el-input v-model="form.verificationCode" placeholder="请输入验证码">
            <template slot-append>
              <img src="path/to/captcha.png" alt="验证码" />
            </template>
          </el-input>
        </el-form-item> -->

        <div class="login-container">
          <WxLogin
            v-if="showQRCode"
            :appid="appid"
            :redirectUri="redirectUri"
            @codeReceived="handleCode"
          />
          <!-- <div id="qrcode" class="qrcode-container" v-if="showQRCode"></div> -->
        </div>

        <div class="agreement" prop="agreement" v-if="!showQRCode">
          <el-checkbox v-model="form.agreement"></el-checkbox
          ><span>已阅读并同意以下协议</span>
          <el-link
            :underline="false"
            type="primary"
            class="int"
            @click="getpdfListData"
          >
            用户协议、</el-link
          >
          <el-link
            :underline="false"
            type="primary"
            class="int"
            @click="getpdfsListData"
            >隐私协议</el-link
          >
        </div>

        <el-form-item style="margin-top: 20px;">
          <el-button
            type="primary"
            style="width: 145%; margin-left: -101px;"
            @click="submit"
            :disabled="form.agreement == false"
            v-if="showQRCode == false"
            >{{ isRegister ? "注册" : "登录" }}</el-button
          >
          <div style="height: 50px;" v-if="showQRCode == true"></div>
          <div class="login-link">
            <span v-if="isRegister">已有账户, </span
            ><a href="javascript:void(0);" @click="toggleForm"
              >去{{ isRegister ? "登录" : "注册" }}</a
            >
          </div>

          <div class="link">
            <el-link
              type="primary"
              v-if="showQRCode == false"
              :underline="false"
              @click="toggleForms"
              >微信扫码登录</el-link
            >
            <el-link
              type="primary"
              v-if="showQRCode == true"
              :underline="false"
              @click="toggleFormm"
              >去登录</el-link
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="绑定手机号"
      class="newstaionn"
      :visible.sync="dialogVisible"
      width="400px"
      @close="handleClose"
    >
      <el-form :model="formm" :rules="rulesm" ref="formRefm">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <span class="dialog-footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="pdfDialogVisible" title="用户协议" width="80%">
      <!-- 使用 iframe 嵌入 PDF 文件 -->
      <iframe
        v-if="pdfDialogVisible"
        :src="pdfUrl"
        width="100%"
        height="650px"
        frameborder="0"
      ></iframe>
    </el-dialog>
    <el-dialog :visible.sync="pdfsDialogVisible" title="隐私协议" width="80%">
      <!-- 使用 iframe 嵌入 PDF 文件 -->
      <iframe
        v-if="pdfsDialogVisible"
        :src="pdfsUrl"
        width="100%"
        height="650px"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import WxLogin from "./child.vue";
export default {
  components: {
    WxLogin,
  },
  data() {
    return {
      dialogVisible: false,
      formm: {
        phone: "",
      },
      rulesm: {
        phone: [
          { required: true, message: "手机号是必填项", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
      },
      captchaEnabled: true,
      codeUrl: "",
      newPasswordType: "password", // 新密码的类型
      confirmPasswordType: "password", // 确认密码的类型
      appid: "wx13d4a3fa0015eb5c", // 替换为你的 App ID
      redirectUri: encodeURIComponent("https://www.hittik.com/wxLogin"), // 替换为你的重定向 URI
      showQRCode: false, // 控制表单状态
      passwordError: null, // 用于存储密码验证的错误信息
      // 用于存储选中的级联值
      cascaderData: [], // 级联选择器的数据
      rules: {
        username: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, message: "密码长度至少为8位", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{1,6}$/,
            message: "验证码格式不正确，需为1到6位数字",
            trigger: "blur",
          },
        ],
        deptId: [{ required: true, message: "请选择省市", trigger: "change" }],
        agreement: [
          { required: true, message: "请勾选已阅读并同意", trigger: "change" },
        ],
        selectedTrade: [
          { required: true, message: "请选择行业", trigger: "change" },
        ],
      },
      userType: "enterprise", // 默认选中企业用户
      form: {
        deptId: "",
        tradeName: "",
        username: "",
        type: 0,
        password: "",
        verificationCode: "",
        agreement: true,
        // code: '',
        selectedTrade: [],
        // uuid: ''
      },

      provinces: [],
      pdfDialogVisible: false, // 控制弹框显示
      pdfUrl: "", // PDF 文件的 URL
      pdfsUrl: "", // PDF 文件的 URL
      pdfsDialogVisible: false, // 控制弹框显示

      industryes: [
        // 行业数据
        { label: "行业1", value: "行业1" },
        { label: "行业2", value: "行业2" },
        // 更多行业选项...
      ],
    };
  },

  computed: {
    ...mapGetters(["isDialogVisible"]), // 直接使用 getters
    ...mapGetters(["isRegister"]),
    ...mapGetters(["isLogin"]), // get isLogin from Vuex
  },

  methods: {
    toggleConfirmPasswordView() {
      this.confirmPasswordType =
        this.confirmPasswordType === "password" ? "text" : "password";
    },

    async getpdfListData() {
      this.pdfDialogVisible = true;
      this.$api.getTitle().then((responses) => {
        if (responses) {
          const newdata = responses;
          this.pdfUrl = this.extractUrls(newdata.userAgreement);
        }
      });
    },
    async getpdfsListData() {
      this.pdfsDialogVisible = true;
      this.$api.getTitle().then((responses) => {
        if (responses) {
          const newdata = responses;
          this.pdfsUrl = this.extractUrls(newdata.privacyAgreement);
        }
      });
    },
    extractUrls(images) {
      return images.map((img) => {
        const urlMatch = img.match(/<url.*?>(.*?)<\/url>/);
        return urlMatch ? urlMatch[1].trim() : img;
      });
    },
    async handleClose() {
      this.$refs.formRefm.validate((valid) => {
        if (valid) {
          this.dialogVisible = false; // 如果验证通过，则关闭弹框
        } else {
          this.dialogVisible = true;
          console.error("手机号验证未通过，弹框将保持开启");
          // 如果验证失败，保持弹框打开，不做任何操作
        }
      });
    },

    async submitForm() {
      await this.$refs.formRefm.validate((valid) => {
        if (valid) {
          this.gotologin(this.userid, this.formm.phone);
        } else {
          this.dialogVisible = true;
          console.error("手机号验证未通过，弹框将保持开启");
          // 如果验证失败，保持弹框打开，不做任何操作
        }
      });
    },

    async gotolist(userId) {
      try {
        this.$api
          .getUserInfo({
            userId: userId,
          })
          .then((responses) => {
            if (responses) {
              //console.log(response.data);
              const userInfo = responses;
              localStorage.setItem(
                "phonedigits",
                userInfo.phonenumber.slice(-4)
              );
              console.log(userInfo.phonenumber.slice(-4));

              this.$store.dispatch(
                "setPhoneLastDigits",
                userInfo.phonenumber.slice(-4)
              );
              this.dialogVisible = false; // 如果验证通过，则关闭弹框

              this.$store.commit("setDialogVisible", false);
              window.location.href = "/home";
            }
          });
      } catch (error) {
        // 处理错误
        console.error("请求失败:", error);
      }
    },
    async gotomorelist(userId) {
      try {
        this.$api
          .getUserInfo({
            userId: userId,
          })
          .then((responses) => {
            if (responses) {
              //console.log(response.data);
              const userInfo = responses;
              localStorage.setItem(
                "phonedigits",
                userInfo.phonenumber.slice(-4)
              );
              console.log(userInfo.phonenumber.slice(-4));

              this.$store.dispatch(
                "setPhoneLastDigits",
                userInfo.phonenumber.slice(-4)
              );
              this.dialogVisible = false; // 如果验证通过，则关闭弹框

              this.$store.commit("setDialogVisible", false);
              // window.location.href = "/home";
            }
          });
      } catch (error) {
        // 处理错误
        console.error("请求失败:", error);
      }
    },
    async gotosearchh() {
      const userId = localStorage.getItem("userId");

      this.$api
        .getUserfunusenum({
          userId: userId,
        })
        .then((responses) => {
          if (responses) {
          }
        });
    },
    gtkookm(forms) {
      this.$api.login(forms).then((response) => {
        if (response) {
          this.$message({
            message: "登录成功",
            type: "success",
            duration: 500, // 可选类型：success、warning、info、error
          });
          const token = response.access_token;
          const userId = response.userid;

          localStorage.setItem("token", token);
          localStorage.setItem("userId", userId);
          this.$store.commit("SET_LOGIN", true);

          this.refreachToken();
          this.gotolist(userId);
          this.gotosearchh();
        }
      });
    },

    async refreachToken() {
      const token = { Authorization: localStorage.getItem("token") };

      // this.$api.refresh(token).then((response) => {
      //   if (response) {
      //     console.error("response:", response);
      //   }
      // });
    },

    gtkook(forms) {
      const url = "https://www.hittik.com/znauth/login";

      this.$api.login(forms).then((response) => {
        if (response) {
          this.$message({
            message: "登录成功",
            type: "success",
            duration: 500, // 可选类型：success、warning、info、error
          });
          const token = response.access_token;
          const userId = response.userid;

          localStorage.setItem("token", token);
          localStorage.setItem("userId", userId);
          this.$store.commit("SET_LOGIN", true);
          console.log(this.$store, forms.username.slice(-4));
          localStorage.setItem("phonedigits", forms.username.slice(-4));
          setTimeout(() => {
            this.refreachToken();
            this.gotosearchh();
          }, 2000);

          this.$store.dispatch("setPhoneLastDigits", forms.username.slice(-4));
        }
      });
    },

    async gotologin(potid, phone) {
      this.$api
        .weChatloginnumber({
          userId: potid,
          phone: phone,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            const newsList = responses;
            console.log(newsList, "newsList");
            var forms = {
              username: this.formm.phone,
              password: "admin246",
            };
            this.gtkook(forms);
            this.dialogVisible = false; // 如果验证通过，则关闭弹框

            this.$store.commit("setDialogVisible", false);
          } else {
            console.log("login fail");
          }
        });
      const url = `https://www.hittik.com/znsystem/weixin/weChatloginnumber?userId=${potid}&phone=${phone}`;

      // try {
      //   // 发起 GET 请求并传入 code 和 state
      //   const res = await this.axios.get(url);
      //   if (res.data.code == 200) {
      //     const newsList = res.data.data;
      //     console.log(newsList, "newsList");
      //     var forms = {
      //       username: this.formm.phone,
      //       password: "admin246",
      //     };
      //     this.gtkook(forms);
      //     this.dialogVisible = false; // 如果验证通过，则关闭弹框

      //     this.$store.commit("setDialogVisible", false);
      //   } else {
      //     console.log("login fail");
      //   }
      //   // 进一步处理 newsList 数据
      // } catch (error) {
      //   console.error("Error fetching data:", error);
      //   // 在此处理错误，例如显示错误信息给用户
      // }
    },
    async handleCode(code, state) {
      console.log("Received code from child:", code, state);

      // 拼接请求 URL
      const url = `https://www.hittik.com/znsystem/weixin/vxcallback?code=${code}&state=${state}`;
      this.$api
        .vxcallback({
          code: code,
          state: state,
        })
        .then((responses) => {
          if (responses) {
           
            const msg = responses;
             console.log(msg);
            if (msg.startsWith("success:")) {
              // 直接登录
              var forms = {
                username: 16639516855,
                password: "admin246",
              };
             var  useridS = msg.split(":")[1];
               this.gotomorelist(useridS);

              //this.gtkookm(forms);
            } else if (msg.startsWith("phone:")) {
              // 第一次扫码，需要绑定手机号
              this.$store.commit("setDialogVisible", false);
              this.userid = msg.split(":")[1]; // 通过 ':' 拆分字符串

              this.dialogVisible = true;
            }
          }
        });
      // try {
      //   // 发起 GET 请求并传入 code 和 state
      //   const res = await this.axios.get(url);
      //   if (res.data.code == 200) {
      //     const msg = res.data.msg;
      //     if (msg.startsWith("success:")) {
      //       // 直接登录
      //       var forms = {
      //         username: 16639516855,
      //         password: "admin246",
      //       };

      //       this.gtkookm(forms);
      //     } else if (msg.startsWith("phone:")) {
      //       // 第一次扫码，需要绑定手机号
      //       this.$store.commit("setDialogVisible", false);
      //       this.userid = res.data.msg.split(":")[1]; // 通过 ':' 拆分字符串

      //       this.dialogVisible = true;
      //     }

      //   } else {
      //     console.log("login fail");
      //   }
      //   // 进一步处理 newsList 数据
      // } catch (error) {
      //   console.error("Error fetching data:", error);
      //   // 在此处理错误，例如显示错误信息给用户
      // }

      // TODO: 在这里根据 code 进行进一步的处理，如请求用户信息等
      // e.g. this.loginUser(code);
    },
    ...mapActions(["login", "logout"]), // 映射 Vuex 的 actions
    async closeDialog() {
      // 提交 mutation 来关闭弹框
      (this.showQRCode = false), this.$store.commit("setUseisRegister", true);
      this.$store.commit("setDialogVisible", false);
    },
    loadWxLoginSDK() {
      const script = document.createElement("script");
      script.src =
        "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      script.onload = () => {
        // this.initWxLogin();
        this.showQRCode = true;
      };
      document.head.appendChild(script);
    },

    initWxLogin() {
      const self = this; // 保存 this 的引用
      new WxLogin({
        self_redirect: true,
        id: "QR_code",
        appid: "wx13d4a3fa0015eb5c", // 替换为你的 AppID
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent("https://www.hittik.com/wxLogin"), // 替换为你的回调地址
        state: Math.random().toString(36).substr(2),
        style: "black",
        href: "",
      });
      setTimeout(() => {
        self.startPollingForCode();
      }, 800);
    },

    startPollingForCode() {
      const pollingInterval = setInterval(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (code) {
          clearInterval(pollingInterval);
          console.log("获取到的 code:", code);
          // sendCodeToBackend(code); // 调用发送 code 到后端的函数
        } else {
          // console.log("等待用户扫码...");
        }
      }, 5000); // 每5秒检查一次
    },

    sendCodeToBackend(code) {
      // 发送 code 到后端的函数
      console.log("发送 code 到后端:", code);
      // 你这里可以使用 fetch 或 axios 发送请求到后端进行登录处理
    },
    watch: {
      // Watch for changes in the route's query parameters
      "$route.query.code": function (newCode) {
        if (newCode) {
          console.log("等待用户扫码newCodenewCode");
          this.handleCode(newCode); // Handle the obtained code
        }
      },
    },
    storeUserInfo(userInfo) {
      // 这里应该将用户信息存储到你的 Vuex store 或者 localStorage 中
      // 示例 (使用 Vuex):
      this.$store.commit("setUserInfo", userInfo);

      // 示例 (使用 localStorage):
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    showLogin() {
      this.showQRCode = true;
      this.loadWxLoginSDK();
    },
    handleCascaderChange(value) {
      console.log("选中的值:", value);
    },
    transformData(data) {
      return data.map((item) => {
        const { tradeName, tradeId, children } = item;
        const result = {
          tradeName,
          tradeId,
        };
        if (children && children.length > 0) {
          result.children = this.transformData(children);
        }
        return result;
      });
    },
    validatePassword() {
      // 清除之前的错误信息
      this.passwordError = null;

      // 获取输入的密码
      const password = this.form.password;

      // 如果输入为空，不进行验证
      if (!password) {
        return;
      }

      // 验证密码长度
    },
    validatePhoneNumber() {
      // 清除之前的错误信息
      this.error = null;

      // 获取输入的手机号
      const phoneNumber = this.form.username;

      // 定义手机号的正则表达式

      // 如果输入为空，不进行验证
      if (!phoneNumber) {
        return;
      }

      // 验证手机号
      // if (!phoneRegex.test(phoneNumber)) {
      //   this.error = '请输入有效的手机号';
      // }
    },

    submit() {
      if (this.isRegister) {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            // alert('表单验证通过');

            if (this.form.selectedTrade.length > 0) {
              this.form.tradeName = this.form.selectedTrade[
                this.form.selectedTrade.length - 1
              ];
            } else {
              this.form.tradeName = "";
            }
            this.$api.register(this.form).then((response) => {
              if (response != null) {
                let objs = {
                  ip: "",
                  userId: response,
                };
          
                   const url = "https://www.hittik.com/znsystem/thirdparty/insertRecordAccess";
      // const url = "http://192.168.80.81:8080/znsystem/thirdparty/insertRecordAccess";
                var campaignParams = localStorage.getItem("campaignParams");
                
                if (campaignParams != null) {
                  const mb = JSON.parse(campaignParams);

                  Object.assign(objs, mb);
                }
                this.axios.post(url, objs).then((response) => {
                  if (response) {
                    console.log(response, "6666");
                  }
                });
                this.$message({
                  message: "注册成功",
                  type: "success", // 可选类型：success、warning、info、error
                });
                setTimeout(() => {
             
                  this.$store.commit("setUseisRegister", false);
                }, 450);
              } else {
                if (response.msg.includes("注册账号已存在")) {
                  this.$store.commit("setUseisRegister", false);
                }
                this.$message({
                  message: response.msg,
                  type: "error", // 可选类型：success、warning、info、error
                });
              }
            });
          } else {
          }
        });
      } else {
        const url = "https://www.hittik.com/znauth/login";

        this.$api.login(this.form).then((response) => {
          if (response) {
            this.$message({
              message: "登录成功",
              type: "success",
              duration: 500, // 可选类型：success、warning、info、error
            });
            const token = response.access_token;
            const userId = response.userid;
            localStorage.setItem("token", token);
            localStorage.setItem("userId", userId);
            this.$store.commit("SET_LOGIN", true);
            this.$store.commit("setUseisRegister", true);
            localStorage.setItem("phonedigits", this.form.username.slice(-4));
            this.$store.dispatch(
              "setPhoneLastDigits",
              this.form.username.slice(-4)
            );
            console.log(this.$store);
            this.refreachToken();
            this.closeDialog();
            this.gotosearchh();
          } else {
            this.$message({
              message: response.msg,
              type: "error", // 可选类型：success、warning、info、error
            });
            console.error("Error:", response);
          }
        });
      }
    },
    toggleShow() {
      this.$store.commit("setDialogVisible", false); // 提交mutation来关闭
    },

    handleRegister() {},
    toggleForm() {
      if (this.isRegister) {
        this.$store.commit("setUseisRegister", false);
      } else {
        this.$store.commit("setUseisRegister", true);
      }

      this.showQRCode = false;
    },
    toggleFormm() {
      // this.isRegister = true;
      this.showQRCode = false;
      this.$store.commit("setUseisRegister", false);
    },
    toggleForms() {
      this.$store.commit("setUseisRegister", false);

      this.loadWxLoginSDK(); // 加载微信 SDK 并初始化
    },
    async getCardListData() {
      const token = localStorage.getItem("token");
      let config = {};
      if (token) {
        config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getSection?parentId=0",
      //   config
      // );

      this.$api
        .getSection({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            const newsList = responses.area;
            const result = newsList.map((item) => ({
              label: item.districtName,
              value: item.districtId,
            }));
            this.provinces = result;
          }
        });

      this.$api
        .getDictionary({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            const cascaderData = this.transformData(responses);
            this.cascaderData = cascaderData;
          }
        });
      // const resS = await this.axios.get(

      //   "https://www.hittik.com/zntop/top/getDictionary?parentId=0",
      //   config
      // );
    },
  },

  mounted() {
    this.getCardListData();
    // this.getCode();
    console.log("......................");
  },
};
</script>
<style scoped>
.login-link {
  margin-top: 10px;
  text-align: center;

  margin-left: -299px;
}
.demo-ruleForm {
  width: 100%;
  /* padding-left: 3.48958vw; */
  /* display: flex
; */
  /* flex-direction: column; */
  /* position: relative; */

  /* height: 500px; */
  padding: 50px;
  padding-left: 17px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: normal;
}

::v-deep .el-form-item__label {
  text-align: left; /* 设置 label 文本左对齐 */
}
::v-deep .el-dialog {
  border-radius: 4px;
  border-bottom: none;
}
::v-deep .el-dialog__header {
  border-bottom: none;
}

.login-container {
  background: white;
  text-align: center;
  /* border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center; */
}

.qrcode-container {
  margin: 20px 0;
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 4px;
}

.hand {
  width: 268px;
  height: 58px;
}
.title {
  width: 100%;
  display: flex;
  /* padding: 5px; */
  justify-content: center;
  margin-top: -1.04167vw;
}

.title-text {
  width: 142px;
  height: 36px;
  font-family: Source Han Sans CN;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 4px;
  text-align: center;
  color: #06134a;
  margin-top: 12px;
}
.agreement {
  /* position: absolute; */
  display: flex;
  /* margin-bottom: 0.78125vw; */
  bottom: 5.10417vw;
  /* left: 12.39583vw; */

  margin-top: -0.72917vw;
  margin-left: 15px;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  align-items: center;
}
.int {
  margin-top: -1px;
}
.link {
  margin-top: -41px;
  /* right: 0; */
  margin-left: 80px;
}
.links {
  margin-top: -40px;
  /* right: 0; */
  margin-left: 80px;
}
/* ::v-deep .el-select {
 

}
::v-deep .el-cascader .el-input .el-input__inner {
  width: 217px !important;
} */
.neddselect {
  width: 280px !important;
}

.login-code {
  position: relative;
  margin-left: 170px;
  margin-top: -46px;
}
.login-code-img {
  width: 109px;
  height: 45px;
}

.circle-radio .el-radio__input {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  border: 2px solid #dcdfe6;
  background-color: #fff;
  position: relative;
  margin-right: 6px;
}

/* 隐藏默认选中的小实心圆点 */
.circle-radio .el-radio__input.is-checked .el-radio__inner {
  background-color: #fff;
  border-color: #409eff;
}

/* 取消默认的实心圆点 */
.circle-radio .el-radio__input.is-checked .el-radio__inner::after {
  content: "✔";
  color: #409eff;
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -56%);
}

/* 默认圆圈边框颜色 */
.circle-radio .el-radio__inner {
  border-color: #dcdfe6;
}

/* 文本样式 */
.circle-radio .el-radio__label {
  font-size: 14px;
  color: #606266;
}
</style>
